import { RawMeasurementQU } from './Common';

export type StoreCrops = {
  [cropCode: string]: Crop
}

export enum ProductType {
  HYBRID = 'hybrid',
  VARIETY = 'variety',
  UNKNOWN = 'unknown',
}

export type Crop = {
  'updated-at': string;
  name: string;
  'legacy-id': number;
  'product-type': ProductType;
  code: string;
  uuid: string;
  'dfp-uuid': string;
  customNominalWeight?: number;
  'shrink-factor'?: number;
  'nominal-moisture'?: RawMeasurementQU | null;
  'nominal-weight'?: RawMeasurementQU | null;
};

export type OLCropResponse = {
  data: {
    crops: {
      nodes: OLCrop[]
    }
  }
}

export type OLCrop = {
  id: string;
  name: string;
  breedingMethod: BreedingMethod;
  updatedAt: string;
  cropLegacyIds: {
    id: string
    cropCode: string
    uuid: string
  };
  nominalWeight?: RawMeasurementQU | null;
  nominalMoisture?: RawMeasurementQU | null;
}

export enum BreedingMethod { // same as product-type, but all upper case
  HYBRID = 'HYBRID',
  VARIETY = 'VARIETY',
  UNKNOWN = 'UNKNOWN'
}
